import type { BabyBjornOrderType } from "@babybjorn/utils/commercetools/custom-types/babybjorn-order";
import type {
	Order,
	Payment,
	PaymentInfo,
	PaymentReference,
} from "@commercetools/platform-sdk";
import { hasSingleItem } from "../../utils/type-guards/general";
import { fetchFromCTWithSession } from "./frontend-session";

const projectKey = process.env.GATSBY_COMMERCETOOLS_PROJECT_KEY;

const defaultExpandParameters = `?expand=discountCodes[0].discountCode&expand=paymentInfo.payments[*]&expand=shippingInfo.shippingMethod`;

export interface ExpandedPaymentReference extends PaymentReference {
	obj: Payment;
}

interface PaymentInfoWithExpandedPaymentReferences extends PaymentInfo {
	payments: ExpandedPaymentReference[];
}

export interface ExpandedOrder extends Order {
	paymentInfo: PaymentInfoWithExpandedPaymentReferences;
	custom: BabyBjornOrderType;
}

export const getOrderById = async (orderId: string): Promise<ExpandedOrder> => {
	const res = await fetchFromCTWithSession<ExpandedOrder>(
		`/${projectKey}/me/orders/${orderId}${defaultExpandParameters}`,
	);

	if (res.error) {
		throw res.error;
	}

	if (!res.data) {
		throw new Error("Failed to get order.");
	}

	return res.data;
};

export const getOrderByCartId = async (
	cartId: string,
): Promise<ExpandedOrder> => {
	const res = await fetchFromCTWithSession<{ results: ExpandedOrder[] }>(
		`/${projectKey}/me/orders${defaultExpandParameters}&where=cart(id%3D%22${cartId}%22)`,
	);

	if (res.error) {
		throw res.error;
	}

	if (!res.data || res.data.results.length === 0) {
		throw new Error("Failed to get order.");
	}

	if (!hasSingleItem(res.data.results)) {
		throw new Error(
			"Fetching order based on cartId returned multiple orders, that should not be the case.",
		);
	}

	return res.data.results[0];
};
